import InterestsListItem from './InterestsListItem'

export default InterestsListItem
